import { JSXElement, mergeProps } from 'solid-js';
import PortalCustomizations from '~/portal-customization';
import { ConfirmModalProvider } from '~/components/ui/Modal';
import EnvAppPagesErrorBoundary from '~/components/ErrorBoundaries/EnvAppPagesErrorBoundary.tsx';
import EnvAppPagesApiConnector from '~/api/EnvAppPagesApiConnector.tsx';
import EnvAppDataContextProvider from '~/pages/ExternalPages/EnvAppPages/contexts/EnvAppDataContext.tsx';

type EnvAppPagesContainerProps = {
  children: JSXElement;
};

export default function EnvAppPagesContainer(
  props: EnvAppPagesContainerProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <PortalCustomizations>
      <EnvAppPagesErrorBoundary>
        <EnvAppPagesApiConnector>
          <ConfirmModalProvider>
            <EnvAppDataContextProvider>
              {merged.children}
            </EnvAppDataContextProvider>
          </ConfirmModalProvider>
        </EnvAppPagesApiConnector>
      </EnvAppPagesErrorBoundary>
    </PortalCustomizations>
  );
}
